


// import React, { useState } from "react";
// import {
//   Box,
//   Typography,
//   Button,
//   IconButton,
//   TextField,
//   Modal,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   Paper,
// } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
// import "./FmSalaryStructure.css";

// const defaultComponents = [
//   { component: "Basic", calculation: "CTC × 40%" },
//   { component: "HRA", calculation: "Basic × 40%" },
//   { component: "PF", calculation: "System Calculated" },
//   { component: "Special Allowance", calculation: "Balancing Figure" },
// ];

// const CreateSalaryStructure = () => {
//   const [structures, setStructures] = useState([
//     {
//       id: 1,
//       name: "Structure 1",
//       employees: 25,
//       description: "Default salary structure",
//       components: defaultComponents,
//       active: true,
//     },
//     {
//       id: 2,
//       name: "Structure 2",
//       employees: 10,
//       description: "Senior employees structure",
//       components: defaultComponents,
//       active: false,
//     },
//   ]);

//   const [open, setOpen] = useState(false);
//   const [editId, setEditId] = useState(null);
//   const [formData, setFormData] = useState({
//     name: "",
//     employees: "",
//     description: "",
//   });

//   const handleOpen = () => {
//     setFormData({ name: "", employees: "", description: "" });
//     setEditId(null);
//     setOpen(true);
//   };

//   const handleSave = () => {
//     if (editId) {
//       setStructures((prev) =>
//         prev.map((item) =>
//           item.id === editId ? { ...item, ...formData } : item
//         )
//       );
//     } else {
//       setStructures([
//         ...structures,
//         {
//           id: Date.now(),
//           ...formData,
//           components: defaultComponents,
//           active: false,
//         },
//       ]);
//     }
//     setOpen(false);
//   };

//   const handleEdit = (item) => {
//     setEditId(item.id);
//     setFormData(item);
//     setOpen(true);
//   };

//   const handleDelete = (id) => {
//     setStructures(structures.filter((item) => item.id !== id));
//   };

//   const handleUse = (id) => {
//     setStructures((prev) =>
//       prev.map((item) => ({
//         ...item,
//         active: item.id === id,
//       }))
//     );
//   };

//   const activeStructure = structures.find((s) => s.active);

//   return (
//     <Box className="fm-salary-page">
//       {/* Header */}
//       <Box className="fm-header">
//         <Typography className="fm-title">Salary Structures</Typography>
//         <Button
//           className="fm-create-btn"
//           startIcon={<AddCircleOutlineIcon />}
//           onClick={handleOpen}
//         >
//           Create Structure
//         </Button>
//       </Box>

//       {/* Structure List */}
//       <Box className="fm-structure-list">
//         {structures.map((item) => (
//           <Paper
//             key={item.id}
//             className={`fm-structure-card ${
//               item.active ? "active-structure" : ""
//             }`}
//           >
//             <Box>
//               <Typography className="fm-structure-name">
//                 {item.name}
//               </Typography>
//               <Typography className="fm-structure-sub">
//                 Employees: {item.employees}
//               </Typography>
//               <Typography className="fm-structure-desc">
//                 {item.description}
//               </Typography>
//             </Box>

//             <Box className="fm-structure-actions">
//               <Button
//                 size="small"
//                 className="fm-use-btn"
//                 onClick={() => handleUse(item.id)}
//               >
//                 Use
//               </Button>
//               <IconButton onClick={() => handleEdit(item)}>
//                 <EditIcon />
//               </IconButton>
//               <IconButton onClick={() => handleDelete(item.id)}>
//                 <DeleteIcon />
//               </IconButton>
//             </Box>
//           </Paper>
//         ))}
//       </Box>

//       {/* Active Structure Details */}
//       {activeStructure && (
//         <Paper className="fm-details-card">
//           <Typography className="fm-details-title">
//             {activeStructure.name} – Salary Components
//           </Typography>

//           <Table size="small">
//             <TableHead>
//               <TableRow>
//                 <TableCell>Component</TableCell>
//                 <TableCell>Calculation</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {activeStructure.components.map((row, index) => (
//                 <TableRow key={index}>
//                   <TableCell>{row.component}</TableCell>
//                   <TableCell>{row.calculation}</TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </Paper>
//       )}

//       {/* Create / Edit Modal */}
//       <Modal open={open} onClose={() => setOpen(false)}>
//         <Box className="fm-modal">
//           <Typography className="fm-modal-title">
//             {editId ? "Edit Salary Structure" : "Create Salary Structure"}
//           </Typography>

//           <TextField
//             label="Structure Name"
//             fullWidth
//             className="fm-input"
//             value={formData.name}
//             onChange={(e) =>
//               setFormData({ ...formData, name: e.target.value })
//             }
//           />

//           <TextField
//             label="No. of Employees"
//             type="number"
//             fullWidth
//             className="fm-input"
//             value={formData.employees}
//             onChange={(e) =>
//               setFormData({ ...formData, employees: e.target.value })
//             }
//           />

//           <TextField
//             label="Description"
//             multiline
//             rows={3}
//             fullWidth
//             className="fm-input"
//             value={formData.description}
//             onChange={(e) =>
//               setFormData({ ...formData, description: e.target.value })
//             }
//           />

//           <Box className="fm-modal-actions">
//             <Button className="fm-cancel-btn" onClick={() => setOpen(false)}>
//               Cancel
//             </Button>
//             <Button className="fm-save-btn" onClick={handleSave}>
//               Save
//             </Button>
//           </Box>
//         </Box>
//       </Modal>
//     </Box>
//   );
// };

// export default CreateSalaryStructure;




import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  IconButton,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Snackbar
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import "./FmSalaryStructure.css";

// Initial data for salary structures
const initialStructures = [
  {
    id: 1,
    name: "Structure 1",
    code: "GI-600",
    department: "Finance",
    description: "Standard salary structure applicable for employees with CTC below ₹9,00,000 per annum.",
    isDefault: true,

    
    components: [
      { id: 1, label: "Basic", value: "CTC × 20%", type: "percentage" },
      { id: 2, label: "HRA", value: "Basic × 40%", type: "percentage" },
      { id: 3, label: "PF (Employer)", value: "System Calculated", type: "system" },
      { id: 4, label: "ESI (Employer)", value: "System Calculated", type: "system" },
      { id: 5, label: "Food Coupons", value: "₹24,000", type: "fixed" },
      { id: 6, label: "Telephone Allowance", value: "₹12,000", type: "fixed" },
      { id: 7, label: "Internet Allowance", value: "₹30,000", type: "fixed" },
      { id: 8, label: "Leave Travel Allowance", value: "₹15,000", type: "fixed" },
      { id: 9, label: "Gratuity", value: "Basic × 4.81%", type: "percentage" },
      { id: 10, label: "Special Allowance", value: "Balancing CTC", type: "balance" }
    ]
  },
  {
    id: 2,
    name: "Structure 2",
    code: "GI-800",
    department: "Finance",
    description: "Premium salary structure for senior employees with CTC above ₹9,00,000 per annum.",
    isDefault: false,
    components: [
      { id: 1, label: "Basic", value: "CTC × 30%", type: "percentage" },
      { id: 2, label: "HRA", value: "Basic × 50%", type: "percentage" },
      { id: 3, label: "PF (Employer)", value: "System Calculated", type: "system" },
      { id: 4, label: "Car Allowance", value: "₹60,000", type: "fixed" },
      { id: 5, label: "Food Coupons", value: "₹36,000", type: "fixed" },
      { id: 6, label: "Telephone Allowance", value: "₹18,000", type: "fixed" },
      { id: 7, label: "Internet Allowance", value: "₹42,000", type: "fixed" },
      { id: 8, label: "Leave Travel Allowance", value: "₹25,000", type: "fixed" },
      { id: 9, label: "Gratuity", value: "Basic × 4.81%", type: "percentage" },
      { id: 10, label: "Special Allowance", value: "Balancing CTC", type: "balance" }
    ]
  }
];

const CreateSalaryStructure = () => {
  // State management
  const [structures, setStructures] = useState(initialStructures);
  const [selectedStructure, setSelectedStructure] = useState(initialStructures[0]);
  const [editMode, setEditMode] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
  
  // Form state for new structure
  const [newStructure, setNewStructure] = useState({
    name: "",
    code: "",
    department: "Finance",
    description: "",
    components: []
  });
  
  // Handle structure selection
  const handleStructureChange = (event) => {
    const structureId = event.target.value;
    const structure = structures.find(s => s.id === structureId);
    if (structure) {
      setSelectedStructure(structure);
      setEditMode(false);
    }
  };
  
  // Open modal for creating new structure
  const handleOpenModal = () => {
    setNewStructure({
      name: "",
      code: "",
      department: "Finance",
      description: "",
      components: []
    });
    setModalOpen(true);
  };
  
  // Close modal
  const handleCloseModal = () => {
    setModalOpen(false);
  };
  
  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewStructure(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  // Create new salary structure
  const handleCreateStructure = () => {
    if (!newStructure.name || !newStructure.code || !newStructure.description) {
      setSnackbar({
        open: true,
        message: "Please fill all required fields",
        severity: "error"
      });
      return;
    }
    
    const newId = structures.length > 0 ? Math.max(...structures.map(s => s.id)) + 1 : 1;
    const structureToAdd = {
      ...newStructure,
      id: newId,
      isDefault: false,
      components: newStructure.components.length > 0 ? newStructure.components : [
        { id: 1, label: "Basic", value: "CTC × 20%", type: "percentage" },
        { id: 2, label: "HRA", value: "Basic × 40%", type: "percentage" },
        { id: 3, label: "PF (Employer)", value: "System Calculated", type: "system" },
        { id: 4, label: "ESI (Employer)", value: "System Calculated", type: "system" },
        { id: 5, label: "Special Allowance", value: "Balancing CTC", type: "balance" }
      ]
    };
    
    setStructures(prev => [...prev, structureToAdd]);
    setSelectedStructure(structureToAdd);
    setModalOpen(false);
    setSnackbar({
      open: true,
      message: `Salary structure "${newStructure.name}" created successfully!`,
      severity: "success"
    });
  };
  
  // Set structure as default
  const handleSetDefault = () => {
    const updatedStructures = structures.map(structure => ({
      ...structure,
      isDefault: structure.id === selectedStructure.id
    }));
    
    setStructures(updatedStructures);
    setSelectedStructure(prev => ({ ...prev, isDefault: true }));
    setSnackbar({
      open: true,
      message: "Default salary structure updated!",
      severity: "success"
    });
  };
  
  // Save description edits
  const handleSaveDescription = () => {
    const updatedStructures = structures.map(structure => 
      structure.id === selectedStructure.id 
        ? { ...structure, description: selectedStructure.description } 
        : structure
    );
    
    setStructures(updatedStructures);
    setEditMode(false);
    setSnackbar({
      open: true,
      message: "Description updated successfully!",
      severity: "success"
    });
  };
  
  // Open delete confirmation modal
  const handleOpenDeleteModal = () => {
    if (selectedStructure.isDefault) {
      setSnackbar({
        open: true,
        message: "Cannot delete the default structure. Set another as default first.",
        severity: "error"
      });
      return;
    }
    setDeleteModalOpen(true);
  };
  
  // Delete structure
  const handleDeleteStructure = () => {
    const updatedStructures = structures.filter(s => s.id !== selectedStructure.id);
    
    if (updatedStructures.length > 0) {
      setStructures(updatedStructures);
      setSelectedStructure(updatedStructures[0]);
      setDeleteModalOpen(false);
      setSnackbar({
        open: true,
        message: "Salary structure deleted successfully!",
        severity: "success"
      });
    } else {
      setSnackbar({
        open: true,
        message: "Cannot delete the only structure",
        severity: "error"
      });
    }
  };
  
  // Add new salary component
  const handleAddComponent = () => {
    const newComponent = {
      id: selectedStructure.components.length + 1,
      label: "New Component",
      value: "₹0",
      type: "fixed"
    };
    
    const updatedStructure = {
      ...selectedStructure,
      components: [...selectedStructure.components, newComponent]
    };
    
    setSelectedStructure(updatedStructure);
    
    // Update in structures array
    const updatedStructures = structures.map(structure => 
      structure.id === selectedStructure.id ? updatedStructure : structure
    );
    
    setStructures(updatedStructures);
  };
  
  // Close snackbar
  const handleCloseSnackbar = () => {
    setSnackbar(prev => ({ ...prev, open: false }));
  };
  
  return (
    <Box className="fm-salary-page">
      {/* Header with structure selector */}
      <Box className="fm-salary-header">
        <Typography variant="h5" className="fm-page-title">
          Salary Structure Management
        </Typography>
        
        <Box className="fm-structure-selector">
          <FormControl size="small" className="fm-structure-dropdown">
            <InputLabel>Select Structure</InputLabel>
            <Select
              value={selectedStructure.id}
              label="Select Structure"
              onChange={handleStructureChange}
            >
              {structures.map(structure => (
                <MenuItem key={structure.id} value={structure.id}>
                  {structure.name} {structure.isDefault && "(Default)"}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          
          <Button 
            className="fm-create-btn"
            onClick={handleOpenModal}
          >
            + Create New
          </Button>
        </Box>
      </Box>
      
      {/* Overview Card */}
      <Paper className="fm-structure-card">
        <Box className="fm-overview-header">
          <Box>
            <Typography className="fm-section-title">
              {selectedStructure.name} ({selectedStructure.code})
            </Typography>
            <Typography className="fm-section-label">
              {selectedStructure.department} / Salary Configuration
            </Typography>
          </Box>
          
          <Box className="fm-overview-actions">
            {!selectedStructure.isDefault && (
              <Button 
                className="fm-default-btn"
                onClick={handleSetDefault}
              >
                Set as Company Default
              </Button>
            )}
            
            {selectedStructure.isDefault && (
              <Typography color="primary" variant="caption">
                ✓ Default Structure
              </Typography>
            )}
            
            <IconButton onClick={() => setEditMode(true)}>
              <EditIcon />
            </IconButton>
            
            <IconButton 
              className="fm-delete-btn"
              onClick={handleOpenDeleteModal}
              disabled={selectedStructure.isDefault}
            >
              <DeleteIcon />
            </IconButton>
          </Box>
        </Box>
        
        <Box className="fm-overview-content">
          <Typography className="fm-section-label">Description</Typography>
          
          {editMode ? (
            <TextField
              fullWidth
              multiline
              rows={3}
              value={selectedStructure.description}
              onChange={(e) => setSelectedStructure(prev => ({ 
                ...prev, 
                description: e.target.value 
              }))}
            />
          ) : (
            <Typography className="fm-description-text">
              {selectedStructure.description}
            </Typography>
          )}
        </Box>
        
        {editMode && (
          <Box className="fm-action-buttons">
            <Button
              className="fm-cancel-btn"
              onClick={() => setEditMode(false)}
            >
              Cancel
            </Button>
            <Button
              className="fm-save-btn"
              onClick={handleSaveDescription}
            >
              Save Changes
            </Button>
          </Box>
        )}
      </Paper>
      
      {/* Salary Components Table */}
      <Paper className="fm-components-card">
        <Typography className="fm-section-title">
          Salary Components (Annual)
        </Typography>
        
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow className="fm-table-head">
                <TableCell>Component</TableCell>
                <TableCell>Calculation / Value</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedStructure.components.map((item) => (
                <TableRow key={item.id} hover>
                  <TableCell>{item.label}</TableCell>
                  <TableCell>{item.value}</TableCell>
                  <TableCell align="center">
                    <Box className="fm-table-actions">
                      <IconButton size="small" className="fm-edit-btn">
                        <EditIcon fontSize="small" />
                      </IconButton>
                      <IconButton size="small" className="fm-delete-btn">
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        
        <Box className="fm-add-component" onClick={handleAddComponent}>
          <AddCircleOutlineIcon />
          <span>Add Salary Component</span>
        </Box>
      </Paper>
      
      {/* Create Structure Modal */}
      <Modal open={modalOpen} onClose={handleCloseModal}>
        <Box className="fm-modal-box">
          <Box className="fm-modal-header">
            <Typography className="fm-modal-title">
              Create New Salary Structure
            </Typography>
            <IconButton onClick={handleCloseModal} className="fm-modal-close">
              <CloseIcon />
            </IconButton>
          </Box>
          
          <Box>
            <div className="fm-form-group">
              <label className="fm-form-label">Structure Name *</label>
              <TextField
                fullWidth
                size="small"
                name="name"
                value={newStructure.name}
                onChange={handleInputChange}
                placeholder="e.g., Structure 3"
              />
            </div>
            
            <div className="fm-form-group">
              <label className="fm-form-label">Structure Code *</label>
              <TextField
                fullWidth
                size="small"
                name="code"
                value={newStructure.code}
                onChange={handleInputChange}
                placeholder="e.g., GI-1000"
              />
            </div>
            
            <div className="fm-form-group">
              <label className="fm-form-label">Department</label>
              <FormControl fullWidth size="small">
                <Select
                  name="department"
                  value={newStructure.department}
                  onChange={handleInputChange}
                >
                  <MenuItem value="Finance">Finance</MenuItem>
                  <MenuItem value="HR">HR</MenuItem>
                  <MenuItem value="IT">IT</MenuItem>
                  <MenuItem value="Sales">Sales</MenuItem>
                  <MenuItem value="Marketing">Marketing</MenuItem>
                </Select>
              </FormControl>
            </div>
            
            <div className="fm-form-group">
              <label className="fm-form-label">Description *</label>
              <TextField
                fullWidth
                multiline
                rows={3}
                name="description"
                value={newStructure.description}
                onChange={handleInputChange}
                placeholder="Describe the salary structure..."
              />
            </div>
          </Box>
          
          <Box className="fm-modal-actions">
            <Button
              className="fm-cancel-btn"
              onClick={handleCloseModal}
            >
              Cancel
            </Button>
            <Button
              className="fm-save-btn"
              onClick={handleCreateStructure}
            >
              Create Structure
            </Button>
          </Box>
        </Box>
      </Modal>
      
      {/* Delete Confirmation Modal */}
      <Dialog open={deleteModalOpen} onClose={() => setDeleteModalOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to delete "{selectedStructure.name}"? This action cannot be undone.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteModalOpen(false)}>Cancel</Button>
          <Button 
            className="fm-delete-btn-modal"
            onClick={handleDeleteStructure}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      
      {/* Snackbar for notifications */}
      <Snackbar 
        open={snackbar.open} 
        autoHideDuration={4000} 
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateSalaryStructure;
